import React, {useCallback, useEffect, useState, useMemo} from 'react';
import Wrapper from "../components/Wrapper";
import Api from "../Api";
import {Helmet} from "react-helmet";
import {amo, crm, input, sip, bitrix, historyHeader, global} from "../translate";
import {
    Paper,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
    FormControlLabel,
    Checkbox,
    Avatar,
    InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CloseIcon from "@mui/icons-material/Close";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "../components/Loader";
import {toast} from "react-toastify";
import Select from "react-select";
import {greenTheme} from "../helpers/style";

const {REACT_APP_SERVER} = process.env;
const primary = REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary;
let newArr = []
const customStyles = {
    menu: (provided) => ({...provided, position: 'absolute', zIndex: 9999, maxHeight: 300}),
    menuPortal: (base) => ({...base, zIndex: 9999}),
    control: (base, state) => ({
        ...base,
        borderRadius: 10,
        minHeight: 40,
        borderColor: state.isFocused ? primary : 'rgba(0,0,0,0.23)',
        boxShadow: state.isFocused ? `0 0 0 2px ${primary}40` : base.boxShadow,
        '&:hover': { borderColor: primary },
    }),
};
function Bitrix24(props) {
    const lang = +localStorage.getItem('atsLang') || 1;
    const [res, setRes] = useState([]);
    const [sipNum, setSip] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const userData = useSelector((state) => state.users.crmData)
    const navigate = useNavigate()
    const [form, setForm] = useState({
        adminId: 0,
        key: '',
        startcall: '',
        domain: userData?.bitrix?.domain,
        lead: {},
    });
    const [callConfig, setCallConfig] = useState({
        default: 0,
        card_type: 'lead',
        assigned: { lead: { status: [], order: 'asc' } },
        call_rate: 0,
        call_card_report: 0,
        responsible: 0,
        show_card: '',
    });
    const [leadTypes, setLeadTypes] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                const {data} = await Api.bitrix_get()
                const admin = await Api.bitrix_admin()

                if (!admin?.data?.admin?.ADMIN) {
                    alert(bitrix.login_admin[lang])
                    return
                }
                if (data.data.result) {
                    let arr = data.data.result.map(s => ({...s, sip: s.sip || ''}))
                    newArr = arr
                    setRes(arr)
                }
                let webhook = newArr.find(w => w.ID === admin?.data?.admin?.ID)
                setForm(prevState => ({
                    ...prevState, key: webhook?.key,  adminId: webhook?.ID
                }))
                setLoading(false)
            } catch (e) {
                console.log(e)
                if(e?.response?.data?.message === 'Application not found'){
                    navigate('/crm_integration#application_not_found')
                }else{
                    console.log(e?.response?.data?.message)

                }
            }
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getAllowed()
                setSip(data.inputNumber?.sip)
            } catch (e) {
            }
        })()
    }, []);
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.bitrix_lead_types();
                if (data?.leadTypes?.length) {
                    setLeadTypes(data.leadTypes);
                }
            } catch (e) {
                // ignore - lead types optional
            }
        })()
    }, []);
    const handleSipConnect = useCallback((item, index) => {
        newArr = newArr.map((a, i) => (i === index ? {...a, sip: item} : a));
        setRes([...newArr]);
    }, [])

    const handleCurrent = useCallback((item) => {
        setRes([...newArr]);
        setSelectedUser(item);
        setForm(prevState => ({
            ...prevState,
            startcall: item?.startcall || ''
        }));
    }, []);
    const handleCorpChange = useCallback((index, corp) => {
        newArr = newArr.map((a, i) => (i === index ? {...a, corporation: +corp} : a));
        setRes([...newArr]);
    }, [])
    const handleSaveRequest = useCallback(async (item, index) => {
        try {
            if (item?.sip) {
                
                if (+item.crmId) {
                    await Api.bitrix_edit({
                        id: item.crmId,
                        ...((form.key != null && form.key !== '') ? { key: form.key } : {}),
                        startcall: form.startcall,
                        adminID: form.adminId,
                        sip: item?.sip,
                        userID: item.ID,
                        corporation: item?.corporation || 0
                    });
                    if (item.crmId && item.sip) {
                        const payload = +(callConfig.call_card_report) === 1
                            ? (() => {
                                const { incoming, outgoing, missed, call_rate, lead, call_card_report, assigned, default: _default, show_card, ...crmPayload } = callConfig;
                                return {
                                    ...crmPayload,
                                    call_card_report: 1,
                                    call_rate,
                                    ...(+(callConfig.responsible) === 1 ? { assigned } : {}),
                                    ...(show_card ? { show_card } : {}),
                                };
                            })()
                            : null;
                        await Api.crmConfigs(payload, item.sip, item.crmId);
                    }
                } else {
                    const {data} = await Api.bitrix_create({
                        ...((form.key != null && form.key !== '') ? { key: form.key } : {}),
                        startcall: form.startcall,
                        adminID: form.adminId,
                        sip: item?.sip,
                        userID: item.ID,
                        corporation: item?.corporation
                    });
                    newArr = newArr.map((a, i) => (i === index ? {...a, crmId: data.crm.id} : a));
                    if (data.crm?.id && item.sip) {
                        const payload = +(callConfig.call_card_report) === 1
                            ? (() => {
                                const { incoming, outgoing, missed, call_rate, lead, call_card_report, assigned, default: _default, show_card, ...crmPayload } = callConfig;
                                return {
                                    ...crmPayload,
                                    call_card_report: 1,
                                    call_rate,
                                    ...(+(callConfig.responsible) === 1 ? { assigned } : {}),
                                    ...(show_card ? { show_card } : {}),
                                };
                            })()
                            : null;
                        await Api.crmConfigs(payload, item.sip, data.crm.id);
                    }
                }
            } else {
                await Api.bitrix_delete_crm(item?.crmId);
                newArr = newArr.map((a, i) => (i === index ? {...a, crmId: 0} : a));
            }
            setRes([...newArr]);
            toast.success(global.success[lang]);
        } catch (e) {

        }
    }, [form, callConfig, lang])

    const handleWebhook = useCallback((name, val) => {
        setForm((prev) => ({...prev, [name]: val}));
    }, []);

    const handleCallConfigSelect = useCallback((name, ev) => {
        setCallConfig(prev => ({...prev, [name]: ev?.value ?? ''}));
    }, []);

    // const callConfigOptions = useMemo(() => {
    //     return {
    //         incoming: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //             { value: 'none', label: historyHeader.unsorted[lang] },
    //         ],
    //         outgoing: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //         ],
    //         missed: [
    //             { value: 'nothing', label: historyHeader.nothing[lang] },
    //             { value: 'contact', label: historyHeader.contact[lang] },
    //             { value: 'contact_deal', label: historyHeader.contact_lead[lang] },
    //             { value: 'none', label: historyHeader.unsorted[lang] },
    //         ],
    //     };
    // }, [lang]);

    const selectedUserData = selectedUser ? res.find((r) => r.ID === selectedUser.ID) || selectedUser : null;

    useEffect(() => {
        if (selectedUserData?.crmId && selectedUserData?.sip) {
            (async () => {
                try {
                    const {data} = await Api.getCrmConfigs(selectedUserData.crmId);
                    if (data.config?.access_actions) {
                        const jsonString = String.fromCharCode(...data.config.access_actions.data);
                        const jsonData = JSON.parse(jsonString);
                        const assignedLead = jsonData.assigned?.lead;
                        const leadActive = assignedLead && (typeof assignedLead === 'object');
                        const lead = leadActive
                            ? { status: Array.isArray(assignedLead.status) ? assignedLead.status : [], order: assignedLead.order || 'asc' }
                            : { status: [], order: 'asc' };
                        const { incoming, outgoing, missed, rated_calls_to_manager, lead: _lead, ...rest } = jsonData;
                        setCallConfig({
                            ...rest,
                            default: +(jsonData.call_rate) === 1 ? 1 : 0,
                            card_type: jsonData.card_type ?? 'lead',
                            assigned: { lead },
                            call_rate: +(jsonData.call_rate) === 1 ? 1 : 0,
                            call_card_report: +(jsonData.call_card_report) === 1 ? 1 : 0,
                            responsible: +(jsonData.responsible) === 1 ? 1 : 0,
                            show_card: (jsonData.show_card === 'only_answer' || jsonData.show_card === 'all') ? jsonData.show_card : '',
                        });
                    } else {
                        setCallConfig({ default: 0, card_type: 'lead', assigned: { lead: { status: [], order: 'asc' } }, call_rate: 0, call_card_report: 0, responsible: 0, show_card: '' });
                    }
                } catch (e) {
                    setCallConfig({ default: 0, card_type: 'lead', assigned: { lead: { status: [], order: 'asc' } }, call_rate: 0, call_card_report: 0, responsible: 0, show_card: '' });
                }
            })();
        } else {
            setCallConfig({ default: 0, card_type: 'lead', assigned: { lead: { status: [], order: 'asc' } }, call_rate: 0, call_card_report: 0, responsible: 0, show_card: '' });
        }
    }, [selectedUserData?.crmId, selectedUserData?.sip]);

    const filteredRes = useMemo(() => {
        if (!searchQuery.trim()) return res;
        const q = searchQuery.toLowerCase();
        return res.filter((s) =>
            `${s.NAME || ''} ${s.LAST_NAME || ''} ${s.EMAIL || ''}`.toLowerCase().includes(q)
        );
    }, [res, searchQuery]);

    const cardPaperSx = {
        p: 2.5,
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.06)',
    };

    return (
        <>
            <Helmet><title>{sip.crm[lang]}</title></Helmet>
            <Wrapper>
                <div className="tableParent">
                    {(form.key || form.startcall) && (
                    <Paper sx={{...cardPaperSx, mb: 3, p: 3}}>
                        <Typography variant="h6" fontWeight={700} sx={{mb: 2, color: 'text.primary'}}>
                            {bitrix.webhook[lang]}
                        </Typography>
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.5, maxWidth: 480}}>
                            <Box>
                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 0.75, color: 'text.secondary'}}>
                                    {bitrix.inbound_webhook[lang]}
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={Cookies.get("key") ? (form.key ? '••••••••••••••••••••' : '') : form.key}
                                    onChange={(ev) => handleWebhook('key', ev.target.value)}
                                    placeholder={bitrix.enter_inbound_webhook[lang]}
                                    disabled={!!Cookies.get("key")}
                                    sx={{'& .MuiOutlinedInput-root': {borderRadius: 2}}}
                                />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 0.75, color: 'text.secondary'}}>
                                    {bitrix.outbound_webhook[lang]}
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={Cookies.get("key") ? (form.startcall ? '••••••••••••••••••••' : '') : form.startcall}
                                    onChange={(ev) => handleWebhook('startcall', ev.target.value)}
                                    placeholder={bitrix.enter_outbound_webhook[lang]}
                                    disabled={!!Cookies.get("key")}
                                    sx={{'& .MuiOutlinedInput-root': {borderRadius: 2}}}
                                />
                            </Box>
                        </Box>
                    </Paper>
                    )}
                </div>

                {loading ? (
                    <div className="loaderContainer"><Loader/></div>
                ) : (
                    <div className="tableParent" id="tableParent" style={{display: 'flex', gap: 24, overflow: 'hidden', minWidth: 0}}>
                        {/* User list - wider than config when both shown */}
                        <Paper sx={{...cardPaperSx, flex: selectedUser ? 1.5 : 1, minWidth: 0, minHeight: 0}}>
                            <Typography variant="subtitle1" fontWeight={700} sx={{mb: 2, color: 'text.primary'}}>
                                {bitrix.user_config[lang]}
                            </Typography>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder={bitrix.search_users[lang]}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{color: 'text.secondary'}}/>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{mb: 2, '& .MuiOutlinedInput-root': {borderRadius: 2}}}
                            />
                            <TableContainer sx={{maxHeight: 420}}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem'}}>{bitrix.bitrix_user[lang]}</TableCell>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem'}}>{bitrix.mapped_to[lang]}</TableCell>
                                            <TableCell sx={{fontWeight: 700, fontSize: '0.75rem', width: 80}}>{historyHeader.status[lang]}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredRes.map((s) => {
                                            const isSelected = selectedUser?.ID === s.ID;
                                            return (
                                                <TableRow
                                                    key={s.ID}
                                                    hover
                                                    selected={isSelected}
                                                    onClick={() => handleCurrent(s)}
                                                    sx={{cursor: 'pointer', bgcolor: isSelected ? `${primary}12` : undefined}}
                                                >
                                                    <TableCell>
                                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                                                            <Avatar sx={{width: 36, height: 36, bgcolor: primary, fontSize: '0.875rem'}}>
                                                                {(s.NAME?.[0] || '') + (s.LAST_NAME?.[0] || '')}
                                                            </Avatar>
                                                            <Box>
                                                                <Typography variant="body2" fontWeight={600}>{s.NAME} {s.LAST_NAME}</Typography>
                                                                <Typography variant="caption" color="text.secondary">{s.EMAIL}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" color="text.secondary">
                                                            {s.sip ? `${s.sip} - ${sipNum.find((k) => +k.number === s.sip)?.context || ''}` : bitrix.not_assigned[lang]}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        {s?.ACTIVE ? (
                                                            <CheckCircleIcon sx={{color: primary, fontSize: 20}}/>
                                                        ) : (
                                                            <RadioButtonUncheckedIcon sx={{color: 'grey.400', fontSize: 20}}/>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {filteredRes.length === 0 && (
                                <Typography variant="body2" color="text.secondary" sx={{py: 3, textAlign: 'center'}}>
                                    {bitrix.no_users_found[lang]}
                                </Typography>
                            )}
                        </Paper>

                        {/* Right panel: Config - only when user selected, narrower than user list */}
                        {selectedUser && (
                        <Paper sx={{...cardPaperSx, flex: 1, minWidth: 0, minHeight: 0, position: 'relative'}}>
                            {selectedUserData && (
                                <>
                                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5}}>
                                        <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                                            {bitrix.config_for[lang]} {selectedUserData.NAME} {selectedUserData.LAST_NAME}
                                        </Typography>
                                        <IconButton size="small" onClick={() => setSelectedUser(null)} sx={{ml: 1}} aria-label="Close">
                                            <CloseIcon fontSize="small"/>
                                        </IconButton>
                                    </Box>
                                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.5}}>
                                        <Box>
                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                {bitrix.user_mapping[lang]}
                                            </Typography>
                                            <Typography variant="body2" sx={{mb: 1}}>{bitrix.bitrix_user[lang]}: {selectedUserData.NAME} {selectedUserData.LAST_NAME}</Typography>
                                            <Box sx={{minWidth: 200}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPortalTarget={document.body}
                                                    onChange={(ev) => handleSipConnect(ev.value, res.findIndex((r) => r.ID === selectedUserData.ID))}
                                                    value={selectedUserData.sip
                                                        ? {label: `${selectedUserData.sip} - ${sipNum.find((k) => +k.number === selectedUserData.sip)?.context || ''}`, value: selectedUserData.sip}
                                                        : {label: input.select[lang], value: ''}}
                                                    options={[{value: '', label: input.select[lang]}, ...sipNum.map((k) => ({value: +k.number, label: `${k.number} - ${k.context || ''}`}))]}
                                                    isSearchable
                                                />
                                            </Box>
                                        </Box>
                                        <Box>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={!!selectedUserData?.corporation}
                                                        onChange={(ev) => handleCorpChange(res.findIndex((r) => r.ID === selectedUserData.ID), +ev.target.checked)}
                                                        sx={{color: primary, '&.Mui-checked': {color: primary}}}
                                                    />
                                                }
                                                label={<Typography variant="body2">{bitrix.boxed_version[lang]}</Typography>}
                                            />
                                        </Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={!!(+(callConfig.call_card_report) === 1)}
                                                    onChange={(ev) => {
                                                        const checked = ev.target.checked;
                                                        setCallConfig(prev => ({
                                                            ...prev,
                                                            call_card_report: checked ? 1 : 0,
                                                            ...(checked ? {} : { responsible: 0, call_rate: 0 }),
                                                        }));
                                                    }}
                                                    sx={{color: primary, '&.Mui-checked': {color: primary}}}
                                                />
                                            }
                                            label={<Typography variant="body2">{bitrix.new_version[lang]}</Typography>}
                                            sx={{mt: 1}}
                                        />
                                        <Box>
                                            <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                {bitrix.show_card_label[lang]}
                                            </Typography>
                                            <Box sx={{minWidth: 200}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPortalTarget={document.body}
                                                    isDisabled={+(callConfig.call_card_report) !== 1}
                                                    value={(() => {
                                                        const v = callConfig.show_card ?? '';
                                                        const opts = [
                                                            {value: '', label: input.select[lang]},
                                                            {value: 'all', label: bitrix.show_card_all[lang]},
                                                            {value: 'only_answer', label: bitrix.show_card_only_answer[lang]},
                                                        ];
                                                        return opts.find(o => o.value === v) || opts[0];
                                                    })()}
                                                    onChange={(ev) => setCallConfig(prev => ({...prev, show_card: ev?.value ?? ''}))}
                                                    options={[
                                                        {value: '', label: input.select[lang]},
                                                        {value: 'all', label: bitrix.show_card_all[lang]},
                                                        {value: 'only_answer', label: bitrix.show_card_only_answer[lang]},
                                                    ]}
                                                    isSearchable={false}
                                                />
                                            </Box>
                                        </Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={+(callConfig.responsible) === 1}
                                                    onChange={(ev) => {
                                                        const checked = ev.target.checked;
                                                        setCallConfig(prev => ({
                                                            ...prev,
                                                            responsible: checked ? 1 : 0,
                                                            ...(checked ? { call_card_report: 1 } : {}),
                                                        }));
                                                    }}
                                                    disabled={+(callConfig.call_card_report) !== 1}
                                                    sx={{color: primary, '&.Mui-checked': {color: primary}, '&.Mui-disabled': {opacity: 0.6}}}
                                                />
                                            }
                                            label={<Typography variant="body2">{bitrix.rated_calls_to_manager[lang]}</Typography>}
                                            sx={{mt: 1}}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={+(callConfig.call_rate) === 1}
                                                    onChange={(ev) => setCallConfig(prev => ({...prev, call_rate: ev.target.checked ? 1 : 0}))}
                                                    disabled={+(callConfig.call_card_report) !== 1}
                                                    sx={{color: primary, '&.Mui-checked': {color: primary}, '&.Mui-disabled': {opacity: 0.6}}}
                                                />
                                            }
                                            label={<Typography variant="body2">{bitrix.rated_calls_to_manager[lang]}</Typography>}
                                            sx={{mt: 1}}
                                        />
                                        {+(callConfig.responsible) === 1 && (
                                        <Box sx={{mt: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                    {amo.paragraph_p3[lang]}
                                                </Typography>
                                                <Box sx={{minWidth: 200}}>
                                                    <Select
                                                        styles={customStyles}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        isDisabled
                                                        value={{value: 'lead', label: bitrix.card_type_lead[lang]}}
                                                        onChange={(ev) => setCallConfig(prev => ({...prev, card_type: ev?.value || 'lead'}))}
                                                        options={[
                                                            {value: 'lead', label: bitrix.card_type_lead[lang]},
                                                            {value: 'contact', label: bitrix.card_type_contact[lang]},
                                                            {value: 'deal', label: bitrix.card_type_deal[lang]},
                                                        ]}
                                                        isSearchable={false}
                                                    />
                                                </Box>
                                            </Box>
                                            {leadTypes.length > 0 && (
                                            <>
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                    {bitrix.lead_types_label[lang]}
                                                </Typography>
                                                <Box sx={{minWidth: 200}}>
                                                    <Select
                                                        isMulti
                                                        styles={customStyles}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        value={(callConfig.assigned?.lead?.status || []).map(id => {
                                                            const lt = leadTypes.find(l => l.id === id);
                                                            return lt ? {value: lt.id, label: lt.name} : {value: id, label: id};
                                                        })}
                                                        onChange={(ev) => setCallConfig(prev => ({
                                                            ...prev,
                                                            assigned: { ...(prev.assigned || {}), lead: { ...(prev.assigned?.lead || { status: [], order: 'asc' }), status: (ev || []).map(o => o.value) } }
                                                        }))}
                                                        options={leadTypes.map(lt => ({value: lt.id, label: lt.name}))}
                                                        isSearchable={false}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight={600} sx={{mb: 1, color: 'text.secondary'}}>
                                                    {bitrix.order_label[lang]}
                                                </Typography>
                                                <Box sx={{minWidth: 200}}>
                                                    <Select
                                                        styles={customStyles}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        value={{value: callConfig.assigned?.lead?.order || 'asc', label: (callConfig.assigned?.lead?.order || 'asc') === 'asc' ? bitrix.order_asc[lang] : bitrix.order_desc[lang]}}
                                                        onChange={(ev) => setCallConfig(prev => ({
                                                            ...prev,
                                                            assigned: { ...(prev.assigned || {}), lead: { ...(prev.assigned?.lead || { status: [], order: 'asc' }), order: ev?.value || 'asc' } }
                                                        }))}
                                                        options={[
                                                            {value: 'asc', label: bitrix.order_asc[lang]},
                                                            {value: 'desc', label: bitrix.order_desc[lang]},
                                                        ]}
                                                        isSearchable={false}
                                                    />
                                                </Box>
                                            </Box>
                                            </>
                                            )}
                                        </Box>
                                        )}
                                        
                                        <Box sx={{display: 'flex', gap: 1.5, pt: 1}}>
                                            <Button
                                                variant="contained"
                                                size="medium"
                                                sx={{bgcolor: primary, '&:hover': {bgcolor: primary}, borderRadius: 2, textTransform: 'none', fontWeight: 600}}
                                                onClick={() => handleSaveRequest(selectedUserData, res.findIndex((r) => r.ID === selectedUserData.ID))}
                                            >
                                                {global.edit[lang]}
                                            </Button>
                                        </Box>
                                    </Box>
                                </>
                            )}
                        </Paper>
                        )}
                    </div>
                )}

                <div className="tableParent" style={{marginTop: 24}}>
                    <Paper sx={{...cardPaperSx, p: 2.5}}>
                        <Typography variant="subtitle1" fontWeight={700} sx={{mb: 1.5, color: 'text.primary'}}>
                            {crm.config[lang]}
                        </Typography>
                        <Box component="ul" sx={{m: 0, pl: 2.5, color: 'text.secondary'}}>
                            <li><Typography variant="body2">{bitrix.card[lang]}</Typography></li>
                            <li><Typography variant="body2">{amo.record[lang]}</Typography></li>
                        </Box>
                    </Paper>
                </div>
            </Wrapper>
        </>
    );
}

export default Bitrix24;
